/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import NumberFormat from "react-number-format";
export const AmountColumnFormatter = (cellContent, row, rowIndex) => {
  const { amount = "0" } = row;

  const amountFormatter = () => {
    return (
      <NumberFormat
        value={amount}
        displayType="text"
        thousandSeparator={true}
        prefix="$"
        decimalSeparator="."
        decimalScale={2}
        fixedDecimalScale={true}
      />
    );
  };

  return (
    <>
      <div>{amountFormatter()}</div>
      <> </>
    </>
  );
};
